import VDatePicker from '@/vuetify_custom/v-date-picker_v1'
import {
  VContainer,
  VRow,
  VCol,
  VSelect,
  VTextField,
  VBtn,
  VCheckbox,
  VDataTable,
  VFileInput,
} from "vuetify/lib";
import { querySpuCostAllocationInfo } from "./service";

export default {
  components: {VDatePicker, VTextField, VBtn, VContainer, VRow, VCol, VSelect, VCheckbox, VDataTable, VFileInput},
  data() {
    const date = new Date()
    const defaultMonth = date.getFullYear() + "-" + (date.getMonth() + 1)

    return {
      loading: true,
      search: {
        customer_name: "",
        customer_uid: "",
        calculate_salary_month: defaultMonth,
      },
      tableHeaders: [
        {
          text: "姓名",
          align: "center",
          value: "customer_name",
          width: 120,
        },
        {
          text: "工号",
          align: "center",
          value: "customer_uid",
          width: 120,
        },
        // {
        //   text: "员工类型",
        //   align: "center",
        //   value: "number",
        //   width: 120,
        // },
        {
          text: "所属部门",
          align: "center",
          value: "team_name",
          width: 120,
        },
        {
          text: "计薪月",
          align: "center",
          value: "calculate_salary_month",
          width: 120,
        },
        {
          text: "发薪月",
          align: "center",
          value: "payment_salary_month",
          width: 120,
        },
        
        {
          text: "BU",
          align: "center",
          value: "business_unit",
          width: 120,
        },
        {
          text: "分配比例",
          align: "center",
          value: "ratio",
          width: 120,
        },
        {
          text: "科目",
          align: "center",
          value: "analysis_title_name",
          width: 120,
        },
        {
          text: "¥",
          align: "center",
          value: "cost_amount",
          width: 120,
        },
      ],
      dataSource: [],
      page: 1,
      options: {},
      total: 0,
    }
  },
  computed: {
    
  },
  watch: {
    options: {
      handler(e) {
        this.getData(e);
      },
      deep: true,
    },
  },
  methods: {
    onSearch() {
      this.options.page = 1;
      this.getData({...this.options, page: 1})
    },
    async getData(pagination) {
      this.loading = true;
      console.log(pagination)

      const search = this.search;
      const filteredSearch = {};
      Object.keys(search).forEach((item) => {
        if (search[item] || search[item] === false) {
          filteredSearch[item] = search[item];
        }
      });
      console.log(filteredSearch)

      const params = {
        page: pagination.page || 1,
        per_page: pagination.itemsPerPage || 10,
        ...filteredSearch
      };
      querySpuCostAllocationInfo(params).then((res) => {
        console.log(res)
        this.dataSource = res.list;
        this.total = res.total_count;
        this.loading = false;
      });
    },
  },
  render() {
    return <div>
      <VContainer fluid>
        <VRow align="center">
        <VCol>
              <VTextField clearable v-model={this.search.customer_name} label="姓名"></VTextField>
            </VCol>
            <VCol>
              <VTextField clearable v-model={this.search.customer_uid} label="工号"></VTextField>
            </VCol>
            <VCol>
              <VDatePicker
                v-model={this.search.calculate_salary_month}
                type="month"
                class="mt-4"
                label="计薪月份"
              ></VDatePicker>
            </VCol>
            <VCol>
              <VBtn
                color="primary"
                elevation="2"
                onClick={() => {
                  this.onSearch();
                }}
              >
                搜索
              </VBtn>
            </VCol>
        </VRow>
      </VContainer>
      <VDataTable 
        loading={this.loading}
        page={this.page}
        options={this.options}
        server-items-length={this.total}
        on={{
          ["update:page"]: (val) => {
            this.page = val;
          },
          ["update:options"]: (val) => {
            this.options = val;
          },
        }}
        items={this.dataSource}
        headers={this.tableHeaders}
      ></VDataTable>
      
    </div>
  }
}